import { configureStore } from "@reduxjs/toolkit";
import companyReducer from './components/AddCompany/endpoints/slice';
import addLocationReducer from './components/AddLocation/endpoints/slice';
import addUserReducer from './components/AddUsers/endpoints/slice';
import candidateSearchViewReducer from './components/Candidates/Search/CandidateSearchView/slice';
import candidateSearchReducer from './components/Candidates/Search/NewCandidateSearch/slice';
import candidateSearchV2Reducer from './components/Candidates/Search/NewCandidateSearchV2/slice';
import searchWithCriteriaReducer from './components/Candidates/Search/SearchwithCriteria/slice';
import searchWithCriteriaV2Reducer from './components/Candidates/Search/SearchwithCriteriaV2/slice';
import headerInfoReducer from './components/common/Header/slice';
import loaderReducer from "./components/common/Loader/slice";
import contactsReducer from "./components/Contacts/slice";
import dashboardReducer from "./components/Dashboard/slice";
import jobListingReducer from './components/JobListing/slice';
import jobOpportunityReducer from "./components/JobOpportunity/slice";
import jobDetailsReducer from './components/JobOpportunity/Summary/slice';
import locationsReducer from "./components/Locations/slice";
import loginReducer from './components/Login/slice';
import locationWithMapReducer from './components/Maps/slice';
import matchingCandidateReducer from './components/MatchingCandidate/slice';
import profileReducer from "./components/Profile/endpoints/slice";
import shiftsountReducer from "./components/ShiftCount/slice";
import shiftsCoverageReducer from './components/ShiftsCoverage/slice';
import signUpReducer from "./components/Signup/slice";
import userReducer from "./components/User/slice";
import viewJobReducer from "./components/ViewJob/slice";
import jobmessagesReducer from './components/jobmessages/slice';
import messagesReucer from './components/Messages/slice';
import messagesheaderReucer from './components/MessagesHeader/slice';
import notificationReducer from "./components/Notification/slice";
import notificationHeaderReducer from './components/NotificationHeader/slice';
import emailSettingsReducer from "./components/EmployerSettings/slice";
import inboxReducer from "./components/Inbox/slice";
import textNotficationReducer from "./components/TextNotification/slice";
import teamsSliceReducer from "./components/CreateTeam/slice";
import gpsSliceReducer from './components/GpsIncident/slice';
import departmentSliceReducer from "./components/Department/slice";
import sharedReducer from "./components/shared/sharedSlice";
import appInsightMiddleware from "./app/AppInsightMiddleware";

export const store = configureStore({
    reducer: {
        shared:sharedReducer,
        login: loginReducer,
        dashboard: dashboardReducer,
        shiftsount: shiftsountReducer,
        loader: loaderReducer,
        signUp: signUpReducer,
        addCompany: companyReducer,
        locations: locationsReducer,
        addLocation: addLocationReducer,
        contacts: contactsReducer,
        user: userReducer,
        addUser: addUserReducer,
        profile: profileReducer,
        candidateSearchInfo: candidateSearchReducer,
        headerInfo: headerInfoReducer,
        jobListing: jobListingReducer,
        jobOpportunity: jobOpportunityReducer,
        jobDetails: jobDetailsReducer,
        candidateSearchViewInfo: candidateSearchViewReducer,
        searchWithCriteriaInfo: searchWithCriteriaReducer,
        matchingCandidateInfo: matchingCandidateReducer,
        shiftsCoverage: shiftsCoverageReducer,
        locationWithMap: locationWithMapReducer,
        candidateSearchInfoV2: candidateSearchV2Reducer,
        searchWithCriteriaInfoV2: searchWithCriteriaV2Reducer,
        messages: messagesReucer,
        messagesheader: messagesheaderReucer,
        jobmessages: jobmessagesReducer,
        viewJobDetails: viewJobReducer,
        notifications: notificationReducer,
        notificationHeader: notificationHeaderReducer,
        emailSettings: emailSettingsReducer,
        inbox: inboxReducer,
        textNotification: textNotficationReducer,
        teams: teamsSliceReducer,
        gps: gpsSliceReducer,
        department: departmentSliceReducer
    },
    middleware:getDefaultMiddleware => getDefaultMiddleware().concat(appInsightMiddleware)
});
